namespace Areas.Projects {
    "use strict";

    const projectWorkflowGridName = "ProjectWorkflowsGrid";

    export function gotoCreateWorkflow() {
        const dataGrid = Areas.getGrid(projectWorkflowGridName);
        const selectedRows: any = dataGrid.getSelectedRowsData();

        if (selectedRows[0] != null) {
            const dataId = selectedRows[0].collaborationAreaId;
            location.href = `/Workflows/Create/CreateFromCollaborationAreaId/${dataId}`;
        }    
        else {
            location.href = "/Workflows/Create/CreateWorkflowNoId/";
        }
    }

    export function gotoEditWorkflow() {
        Areas.gotoSelected(projectWorkflowGridName, "/Workflows/Edit/Index/");
    }

    const viewUrl = "/Workflows/View/Index/";

    export function gotoViewWorkflow() {
        Areas.gotoSelected(projectWorkflowGridName, viewUrl);
    }

    export function viewLinkWorkflow(cellElement, cellInfo) {
        buildCellContent(cellElement, () => { return cellInfo.data.workflowId; },
            `<a href= '${viewUrl}{placeholder}'>View</a>`);
    }

}

